/* Open Shopify's native preferences using its documented public API.
   The link remains a real policy URL when JavaScript or the API is unavailable.
   This helper never sets, assumes, or stores a consent choice. */
(function () {
  'use strict';
  if (window.__anconaPrivacyControls) return;
  window.__anconaPrivacyControls = true;

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target && event.target.closest && event.target.closest('a[data-ancona-cookie-preferences]');
    if (!link) return;
    var banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return;
    event.preventDefault();
    try {
      Promise.resolve(banner.showPreferences()).catch(function () { window.location.assign(link.href); });
    } catch (error) {
      window.location.assign(link.href);
    }
  });
})();
